import React, { FC } from "react";
import ImageComponent from "@tiendeo/react-components/dist/objects/Image/Image";

import useTranslation from "translations/useTranslation";
import useConfigs from "hooks/useConfigs";
import {
    SocialButtonsWrapper,
    FooterSocialsTitle,
    BannerImgLink,
    SocialItemsWrapper,
} from "./Footer.styles";

const PureImageComponent = React.memo(ImageComponent);

interface IAppStore {
    imageUrl: string;
    url: string;
    platform: string;
    alt: string;
}

const AppStore: FC<IAppStore> = ({ imageUrl, url, platform, alt }) => {
    return (
        <BannerImgLink
            title={platform}
            href={url}
            target="_blank"
            rel="noreferrer"
            data-testid="itemFooterApps"
        >
            <PureImageComponent src={imageUrl} threshold={100} useLazyLoad={true} alt={alt} />
        </BannerImgLink>
    );
};

const BannerApp: FC<{}> = () => {
    const t = useTranslation();
    const {
        country_code,
        url_app_android,
        url_app_ios,
        static_url_assets,
        path_image_android_store,
        path_image_ios_store,
    } = useConfigs();

    const lowerCaseCountryCode = country_code.toLocaleLowerCase();

    const imageAndroid = `${static_url_assets}images/mvc/${lowerCaseCountryCode}${path_image_android_store}`;
    const imageIOS = `${static_url_assets}images/mvc/${lowerCaseCountryCode}${path_image_ios_store}`;

    return (
        <SocialButtonsWrapper>
            <FooterSocialsTitle>{t("DOWNLOAD_APP")}</FooterSocialsTitle>
            <SocialItemsWrapper data-testid="footerApps">
                <AppStore
                    imageUrl={imageIOS}
                    url={url_app_ios}
                    platform="iOS App"
                    alt={t("DOWNLOAD_APP")}
                />
                <AppStore
                    imageUrl={imageAndroid}
                    url={url_app_android}
                    platform="Android App"
                    alt={t("DOWNLOAD_APP")}
                />
            </SocialItemsWrapper>
        </SocialButtonsWrapper>
    );
};

export default BannerApp;
